"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBusinessRuleTasks = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseBusinessRuleTasks(processData) {
    const businessRuleTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.BusinessRuleTask);
    const nTasksFound = !((businessRuleTasksRaw === null || businessRuleTasksRaw === void 0 ? void 0 : businessRuleTasksRaw.length) > 0);
    if (nTasksFound) {
        return [];
    }
    const businessRuleTasks = businessRuleTasksRaw.map((businessRuleTaskRaw) => {
        const flowNodeId = businessRuleTaskRaw.id;
        try {
            return parseBusinessRuleTask(businessRuleTaskRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return businessRuleTasks;
}
exports.parseBusinessRuleTasks = parseBusinessRuleTasks;
function parseBusinessRuleTask(businessRuletasksRaw) {
    var _a, _b, _c;
    const businessRuleTask = (0, ActivityFactory_1.createActivityInstance)(businessRuletasksRaw, index_1.Model.Activities.BusinessRuleTask);
    businessRuleTask.decisionRef =
        (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('decisionRef', businessRuleTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
    businessRuleTask.decisionRefBinding =
        (_b = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('decisionRefBinding', businessRuleTask.extensionElements.camundaExtensionProperties)) === null || _b === void 0 ? void 0 : _b.value;
    businessRuleTask.decisionRefVersion =
        (_c = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('decisionRefVersion', businessRuleTask.extensionElements.camundaExtensionProperties)) === null || _c === void 0 ? void 0 : _c.value;
    return businessRuleTask;
}
//# sourceMappingURL=BusinessRuleTaskParser.js.map